import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/clare.jpg"

class Clare extends Component {
  static displayName = "Clare"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "first_name",
      label: "Your first name"
    },
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { styles, elements, ...props } = this.props
    const customFieldCount = elements.custom.length
    const stackedDisplay = customFieldCount > 1

    return (
      <Form {...props} style={styles.forElement("form", {})}>
        <div data-style="clean">
          <Elements.Errors />

          <Elements.CustomFields
            direction={stackedDisplay ? "vertical" : "horizontal"}
            data-stacked={stackedDisplay}
          >
            {stackedDisplay && <Elements.AddFieldButton />}
            <Elements.Button
              name="submit"
              group="button"
              defaults={{ content: "Subscribe" }}
            />
          </Elements.CustomFields>

          {!stackedDisplay && <Elements.AddFieldButton />}

          <Elements.BuiltWith variant="dark" />
        </div>
      </Form>
    )
  }
}

Clare.displayName = "Clare"

export default Clare
